import { IUser } from '@giphy/js-types'
import { Dimensions } from 'types'
import { MediaSprite } from '../../types'
import { ArtboardGifLayerProps, ArtboardImageLayerProps, ArtboardTextLayerProps } from '../artboard-gl/types'

export const ugeCropTypes = ['original', 'landscape', 'square', 'portrait', 'custom'] as const
export type UGECropType = (typeof ugeCropTypes)[number]

export const ugeEditors = ['default', 'captions', 'stickers', 'filters', 'crop', 'layers'] as const
export type UGEEditor = (typeof ugeEditors)[number]

export const ugeStrokeSizes = ['none', 'thin', 'normal', 'thick'] as const
export type UGEStrokeSize = (typeof ugeStrokeSizes)[number]

export const ugeLayerActions = ['duplicate', 'mirror', 'send-to-back', 'delete'] as const
export type UGELayerAction = (typeof ugeLayerActions)[number]
export type UGELayerActionLabels = Partial<Record<UGELayerAction, string>>

export type UGELayerProps = ArtboardGifLayerProps | ArtboardImageLayerProps | ArtboardTextLayerProps

export type UGEGAEventCallback = (event: string, options?: { [key: string]: any }) => void

export type UGELayer = {
    duration: number
    gifId?: string
    id: string
    name?: string
    props: UGELayerProps
    user?: IUser
    searchTerm?: string
    sourceDimensions?: Dimensions
    thumbnailUrl?: string
    type: 'gif' | 'image' | 'sticker' | 'text'
}

export type UGERef = {
    createGIF: () => Promise<File | null>
    createSprite: () => Promise<MediaSprite | null>
    getDimensions: () => Dimensions | null
    getGifIds: () => string[]
    getStickerLayer: () => UGELayer | undefined
}

export const ugeStickerCategories = [
    'giphytrending',
    'giphyfavorites',
    'effects',
    'emoji',
    'accessories',
    'party',
    'holidays',
] as const
export type UGEStickerCategory = (typeof ugeStickerCategories)[number]
